/**
 * Class to show routes reprocessed, and confirmatio by user
 */


Greenmile.RouteDetail = Greenmile.RouteDetail || {};
Greenmile.RouteDetail.PopupConfirmReprocess = function (routeId, data, autoArriveConfiguration) {

    Monet.Form.Modal.apply(this, arguments);

    var hasStopCanceled = false;

    this.rootEl = null;
    this.selector = '#routeMaps_' + routeId;
    this.scopeBlock = this.selector + ' .containerRouteDetail';
    this.cancelCodeField = null;
    this.options = {
        width: 685,
        height: 480
    };

    var toogleLoadingAndReprocessForm = function (context) {

        return function (showLoading) {

            var imgLoading = context.rootEl.querySelector('.loadingPopupFormContainer img');
            var reprocessRouteContainer = context.rootEl.querySelector('.reprocessConfirmRoutes');
            var displayLoading = 'none';
            var displayReprocessForm = 'block';

            if (showLoading) {
                displayLoading = 'block';
                displayReprocessForm = 'none';
            }

            imgLoading.style.display = displayLoading;
            reprocessRouteContainer.style.display = displayReprocessForm;

        };

    }(this);

    var clearIntervalReprocess = function () {
        if (Monet.Session.RouteDetail.screensList[routeId].intervalIdReprocess) {
            clearInterval(Monet.Session.RouteDetail.screensList[routeId].intervalIdReprocess);
        }
    };

    var renderAlertMessage = function (context) {
        return function (message, className) {

            var messageContainer = context.rootEl.querySelector('.alert');

            messageContainer.className = 'alert ' + className;
            messageContainer.style.display = 'block';
            messageContainer.style.margin = '10px';
            messageContainer.style.maxWidth = '86%';
            messageContainer.textContent = '';
            messageContainer.appendChild(document.createTextNode(message));

        };
    }(this);

    var renderErrorMessage = function (message) {
        var defaultErrorKey = Monet.I18n.getResourcesByKey('RouteDetail.ReprocessAutoArrive.errorAtGetRoutesChanged');
        var _message = message || defaultErrorKey;
        renderAlertMessage(_message, 'alert-danger');
    };

    var renderInfoMessage = function (message) {
        renderAlertMessage(message, 'alert-success');
    };

    var sendRouteToReprocess = function (context) {

        return function (listIds) {

            var messageContainer = context.rootEl.querySelector('.alert');
            if(messageContainer) {
                messageContainer.style.display = 'none';
            }

            var ajax = new Monet.Ajax();
            ajax.url = 'AutoArriveServiceRouter/Accept';
            ajax.method = 'post';
            ajax.data = listIds;
            ajax.success = function () {
                context.closeModalWindow();
                const map = Monet.Session.RouteDetail.screensList[routeId].map || null;
                if (map) {
                  const markerStops = new Greenmile.RouteDetail.MarkerStop(map, routeId);
                  markerStops.removeStopsFromMap();
                  markerStops.getStopsAndDrawOnMap();
                }
                new Monet.Maps.Updater().go();
            };
            ajax.error = function (xhr) {
                if (xhr.status === 412 || xhr.status === 409) {
                    var error = JSON.parse(xhr.responseText);
                    renderErrorMessage(Monet.Form.Messages.getErrorMessageToBeDisplayed(error.errorMessages));
                } else {
                    Monet.Configurations.errorNotification(null, xhr);
                }
                toogleLoadingAndReprocessForm(false);
                context.cancelCodeField.postRender();
            };
            toogleLoadingAndReprocessForm(true);
            ajax.send();

        };

    }(this);

    var getStopInfo = function (item) {

        var row = [];

        item.routeBefore.stops.forEach(function (stop) {
            var stopInfo = {
                location: stop.location.key + ' - ' + stop.location.description
            };

            var stopAfter = item.routeAfter.stops.filter(function (stopAfterItem) {
                return stopAfterItem.id === stop.id;
            })[0];

            stopInfo.before = {
                stopToStatus: stop,
                actualArrival: stop.actualArrival,
                actualDeparture: stop.actualDeparture
            };

            stopInfo.after = {
                stopToStatus: stopAfter,
                actualArrival: stopAfter.actualArrival,
                actualDeparture: stopAfter.actualDeparture
            };

            if (stopAfter.canceled) {
                hasStopCanceled = stopAfter.canceled;
            }

            row.push(stopInfo);

        });

        return row;

    };

    var renderChangesByRoute = function (route) {

        var fragment = document.createDocumentFragment();
        var changes = getStopInfo(route);
        var statusStop = function (stop) {
            this.render = function () {
                var status = document.createElement('div');
                status.innerHTML = Greenmile.Utils.getStopStatusIcon({ model: new App.Models.Stop(stop) });
                return status.firstChild;
            };
        };
        var getDataToGrid = function (info, resource) {
            return [
                new Monet.UI.TableViewCell('TEXT', Monet.I18n.getResourcesByKey(resource)),
                new statusStop(info.stopToStatus),
                new Monet.UI.TableViewCell('DATE_TIME', info.actualArrival),
                new Monet.UI.TableViewCell('DATE_TIME', info.actualDeparture)
            ];
        };

        changes.forEach(function (info) {

            var grid = new Monet.UI.TableView();
            var container = document.createElement('div');
            var locationInfo = document.createElement('label');
            var headers = [
                '',
                Monet.I18n.getResourcesByKey('stop.status'),
                Monet.I18n.getResourcesByKey('stop.actualArrival'),
                Monet.I18n.getResourcesByKey('stop.actualDeparture')
            ];

            grid.setHeaders(headers);
            grid.addLine(getDataToGrid(info.before, 'RouteDetail.ReprocessAutoArrive.before'));
            grid.addLine(getDataToGrid(info.after, 'RouteDetail.ReprocessAutoArrive.after'));

            locationInfo.appendChild(document.createTextNode(info.location));

            container.appendChild(locationInfo);
            container.appendChild(grid.render());

            fragment.appendChild(container);
        });

        return fragment;

    };

    var renderWhenSuccess = function (context) {

        return function () {

            var sectionButton = document.createElement('div');
            var btnConfirm = new Monet.UI.Fields.Button();
            var btnCancel = new Monet.UI.Fields.Button();
            var sectionRoute = document.createElement('div');
            var checkAllRoutes = new Monet.UI.Fields.Checkbox();
            var fragment = document.createDocumentFragment();
            var fragmentList = document.createDocumentFragment();
            var checkBoxId = 'checkAllRoutes';
            var listRoute = data.resultList;
            var checkRouteList = [];
            var cancelCode = new Monet.UI.Fields.PowerLookup();

            context.cancelCodeField = cancelCode;

            var renderCancelCode = function () {
                cancelCode.setNameSpace('CancelCodeReprocessAutoArrive');
                cancelCode.setLookUpEntity('CancelCode');
                cancelCode.setDisplayKey('description');
                cancelCode.setInputName('cancelCode');
                cancelCode.render();
                cancelCode.setId('cancelCodeReprocessAutoArrive');
                cancelCode.setValue(autoArriveConfiguration.cancelCode);
                cancelCode.setTextLabel(Monet.I18n.getResourcesByKey('RouteDetail.ReprocessAutoArrive.cancelCode'));
                return cancelCode.rootEl;
            };

            checkRouteList.getChecked = function () {
                return this.filter(function (item) {
                    return item.getValue();
                });
            };

            listRoute.forEach(function (item) {

                var routeBefore = item.routeBefore;
                var container = document.createElement('span');
                var checkRoute = new Monet.UI.Fields.Checkbox();
                var changeContainer = document.createElement('div');
                var textRoute = routeBefore.key + ' - ' + routeBefore.organization.key + ' - ' + Monet.Format.Date.formatToLocale(routeBefore.date);

                checkRoute.render();

                changeContainer.appendChild(renderChangesByRoute(item));

                checkRoute.input.setAttribute('data', routeBefore.id);
                checkRoute.label.innerHTML = textRoute;
                checkRoute.rootEl.className = 'routeInfo';

                checkRoute.input.addEventListener('click', function (e) {
                    var itemChecked = checkRouteList.getChecked().length;
                    var allChecked = itemChecked === checkRouteList.length;
                    checkAllRoutes.setChecked(allChecked);

                    e.stopPropagation();
                });

                checkRouteList.push(checkRoute);
                container.appendChild(checkRoute.rootEl);
                container.appendChild(changeContainer);
                fragmentList.appendChild(container);

            });

            checkAllRoutes.render();

            checkAllRoutes.setChecked(false);
            checkAllRoutes.label.innerHTML = Monet.I18n.getResourcesByKey('RouteDetail.ReprocessAutoArrive.checkAllRoutes');
            checkAllRoutes.label.setAttribute('for', checkBoxId);
            checkAllRoutes.input.setAttribute('id', checkBoxId);
            checkAllRoutes.input.addEventListener('click', function () {
                var checked = this.checked;
                checkRouteList.forEach(function (item) {
                    item.setChecked(checked);
                });
            });

            sectionRoute.className = 'sectionRoute';
            sectionRoute.appendChild(checkAllRoutes.rootEl);
            sectionRoute.appendChild(fragmentList);

            btnConfirm.setValue(Monet.I18n.getResourcesByKey('RouteDetail.ReprocessAutoArrive.save'));
            btnConfirm.addEventClickListener(function () {

                var elementCheckeds = checkRouteList.getChecked();
                if (elementCheckeds.length) {

                    var cancelCodeValue = cancelCode.getValue();
                    var value = {
                        routes: [],
                        token: data.token,
                        tenantId: data.tenantId
                    };

                    if (cancelCodeValue) {
                        value.cancelCode = cancelCodeValue;
                    }

                    elementCheckeds.forEach(function (item) {
                        value.routes.push({ id: item.input.getAttribute('data') });
                    });

                    sendRouteToReprocess(value);
                } else {
                    new Greenmile.Components.AlertModal('RouteDetail.ReprocessAutoArrive.checkSomeOneRoute')
                        .show();
                }
            });

            btnCancel.setValue(Monet.I18n.getResourcesByKey('default.button.cancel'));
            btnCancel.addEventClickListener(function () {
                context.closeModalWindow();
            });

            sectionButton.className = 'sectionButton';
            sectionButton.appendChild(btnCancel.render());
            sectionButton.appendChild(btnConfirm.render());
            if (hasStopCanceled) {
                fragment.appendChild(renderCancelCode());
            }
            fragment.appendChild(sectionRoute);
            fragment.appendChild(sectionButton);

            context.rootEl.querySelector('.reprocessConfirmRoutes').appendChild(fragment);

            $(sectionRoute).accordion({
                header: 'div.routeInfo',
                collapsible: true,
                active: false,
                autoHeight: false,
                icons: {
                    header: 'ui-icon-triangle-1-w'
                }
            });

            if (hasStopCanceled) {
                cancelCode.postRender();
            }

        };

    }(this);

    var renderWhenFail = function () {

        renderErrorMessage(Monet.Form.Messages.getErrorMessageToBeDisplayed(data.errorMessages));
    };

    var retrieveReprocess = function (context) {
        return function () {
            var ajax = new Monet.Ajax();

            ajax.url = 'AutoArriveServiceRouter/Retrieve?criteria={"filters":["*","organization.*","stops.*","stops.location.key","stops.location.description","stops.cancelCode.*", "stops.stopType.type"]}';
            ajax.method = 'post';
            ajax.data = { token: data.token };
            ajax.timeout = 20000;
            ajax.success = function (data = {}) {
                var messageContainer = context.rootEl.querySelector('.alert');
                messageContainer.style.display = 'none';

                if (data.workerStatus === 'SUCCESS' && data.resultList.length) {
                    clearIntervalReprocess();
                    toogleLoadingAndReprocessForm(false);
                    renderWhenSuccess();
                } else if (!data.hasOwnProperty('workerStatus')) {
                    renderInfoMessage(Monet.I18n.getResourcesByKey('RouteDetail.ReprocessAutoArrive.noRouteChanged'));
                    toogleLoadingAndReprocessForm(false);
                }
            };

            ajax.error = function (xhr) {

                clearIntervalReprocess();

                if (xhr.status === 412) {
                    var error = JSON.parse(xhr.responseText);
                    renderErrorMessage(Monet.Form.Messages.getErrorMessageToBeDisplayed(error.errorMessages));
                } else {
                    Monet.Configurations.errorNotification(null, xhr);
                }
            };

            ajax.send();

        };
    }(this);

    var renderWhenIsProcessing = function () {

        var message = Monet.I18n.getResourcesByKey('RouteDetail.ReprocessAutoArrive.processing');
        renderInfoMessage(message, 'alert-success');
        toogleLoadingAndReprocessForm(true);
        clearIntervalReprocess();
        Monet.Session.RouteDetail.screensList[routeId].intervalIdReprocess = setInterval(function () {
            retrieveReprocess();
        }, 20000);

    };

    var contentToPopup = function (context) {

        return function () {

            context.rootEl = document.querySelector(context.selector + ' .popupFormContainer');

            var divError = document.createElement('div');
            var divRouteToReprocess = document.createElement('div');
            var imgLoading = document.createElement('img');
            var divLoading = document.createElement('div');

            divError.className = 'alert';
            divError.style.display = 'none';
            divLoading.className = 'loadingPopupFormContainer';
            imgLoading.src = require("static/images/general/loading_blue.svg");
            imgLoading.style.display = 'none';
            divRouteToReprocess.className = 'reprocessConfirmRoutes';

            const helpIcon = new Monet.UI.Help('AutoArriveReprocess', Monet.I18n.getResourcesByKey('AutoArriveReprocess')).render();
            helpIcon.className += ' helpAutoArriveReprocess';

            divLoading.appendChild(imgLoading);
            context.rootEl.classList.add("popupReprocess");
            context.rootEl.appendChild(helpIcon);
            context.rootEl.appendChild(divLoading);
            context.rootEl.appendChild(divError);
            context.rootEl.appendChild(divRouteToReprocess);

            if (data.workerStatus === 'SUCCESS') {
                renderWhenSuccess();
            } else if (data.workerStatus === 'FAIL') {
                renderWhenFail();
            } else if (data.workerStatus === 'PROCESSING') {
                renderWhenIsProcessing();
            } else {
                renderInfoMessage(Monet.I18n.getResourcesByKey('RouteDetail.ReprocessAutoArrive.noRouteChanged'));
            }

        };

    }(this);

    this.callbacks = {
        onAfterShowModalForm: contentToPopup,
        onAfterCloseModalForm: function () {
            Monet.Session.RouteDetail.screensList[routeId].editingStop = null;
            Monet.Session.RouteDetail.screensList[routeId].isUpdateAutomatic = true;
        }
    };

    this.render = function () {
        this.showModalForm();
    };

};
